import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon"

import MDInput from "components/MDInput";
import MDBox from "components/MDBox";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";

import MDTypography from "components/MDTypography";
import styles from "./index.module.css";

import { PATH, UPLOAD_PATH } from "../../constant";
import 'dayjs/locale/it';

import { DropzoneArea } from 'material-ui-dropzone';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';

import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import * as ajax from "helpers/ajax";
import dayjs from 'dayjs';
import Switch from '@mui/material/Switch';


export class CheckListCommessa extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data:this.props.data
        };
    }

    componentDidMount = () => {
        if (this.state.data.file_path) {
            let formData = new FormData();
            formData.append("path", this.state.data.file_path);
            ajax.ajaxPost("/file_list.php", formData, this.listFilesCallback)
        }
        let el = document.querySelectorAll("[data-meta='MuiTypography']");
        el.forEach((x) => {
            x.disabled = true;
        });
    }

    listFilesCallback = (response) => {
        if (response.message.files.length <= 0) {
            let formData = new FormData();
            formData = {
                "data": { "file_path": null }
            };
            ajax.ajaxPutStrapi("commessa-checklists/" + this.state.data.id, formData, this.saveCallback)
            this.saveBool(false);

            let temp = this.state.data;
            temp.file_path = null;
            this.setState({ data: temp }, this.callBack)
        }
    }

    saveFile = (files) => {
        if (this.props.disabled) { return; }
        if (files.length <= 0) { return; }

        let formData = new FormData();

        formData.append("path", "/commessa/" + this.props.id + "/documentazione di fine lavori/"+this.props.subfolder);
        files.map((file, index) => {
            formData.append("file[]", file);
        })

        ajax.ajaxPost("/file_upload.php", formData)

        formData = {
            "data": { "file_path": "/commessa/" + this.props.id + "/documentazione di fine lavori/" + this.props.subfolder }
        };
        ajax.ajaxPutStrapi("commessa-checklists/" + this.state.data.id, formData, this.saveCallback)

        let temp = this.state.data;
        temp.file_path = "/commessa/" + this.props.id + "/documentazione di fine lavori/" + this.props.subfolder;
        this.setState({ data: temp }, this.callBack)

        if (this.state.data.type == "file&calendar") {
            if (this.state.data.date) {
                this.saveBool(true)
            }
        } else {
            this.saveBool(true)
        }
    }

    saveBool = (val) => {
        let temp = this.state.data;
        temp.completed = val;
        this.setState({ data: temp }, this.callBack)

        let formData = {
            "data": { "completed": val }
        };
        ajax.ajaxPutStrapi("commessa-checklists/" + this.state.data.id, formData, this.saveCallback)

    }

    saveNeeded = (val) => {
        let temp = this.state.data;
        temp.needed = val;
        this.setState({ data: temp }, this.callBack)

        let formData = {
            "data": { "needed": val }
        };
        ajax.ajaxPutStrapi("commessa-checklists/" + this.state.data.id, formData, this.saveCallback)

    }

    callBack = () => {
        this.props.onChange(this.state.data);
    }

    saveData = (val, send = false) => {
        let temp = this.state.data;
        temp.date = val;
        this.setState({ data: temp })

        if (send) {
            let formData = {
                "data": { "date": val }
            };
            ajax.ajaxPutStrapi("commessa-checklists/" + this.state.data.id, formData, this.saveCallback)
            if (this.state.data.type == "file&calendar") {
                if (this.state.data.file_path) {
                    this.saveBool(true)
                }
            } else {
                this.saveBool(true)
            }
        }
    }

    saveCallback = (response) => {
        //console.log(response)
    }


    render() {

        return (
            <MDBox py={2} container>
                <Grid container alignItems="center" className={styles.checklistContainer}>
                    <Grid item mr={2}>
                        <MDAvatar bgColor={(this.state.data.completed || !this.state.data.needed) ? "success" : "error"} size="xs">
                            <Icon fontSize="small">{(this.state.data.completed || !this.state.data.needed) ?"done":"close"}</Icon>
                        </MDAvatar>
                    </Grid>

                    <Grid item xs={3}>
                        <MDTypography>{this.state.data.name}</MDTypography>
                    </Grid>


                    {((this.state.data.type == "file&calendar" || this.state.data.type == "file")) ?
                        <Grid item xs={4} mx={2} sx={{ position: 'relative' }}>
                            <DropzoneArea
                                onChange={(files) => { this.saveFile(files) }}
                                showFileNamesInPreview={true}
                                filesLimit={10}
                                dropzoneText={""}
                                dropzoneClass={this.state.data.file_path ? styles.dropzoneContainerComplete : styles.dropzoneContainer}
                                dropzoneParagraphClass={styles.dropzoneTextContainer}
                                icon={<Icon>person</Icon>}
                                showAlerts={false}
                                showPreviews={false}
                                showPreviewsInDropzone={false}
                            />
                            {this.props.disabled && (
                                <MDBox
                                    sx={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                        cursor: 'not-allowed',
                                        zIndex: 10
                                    }}
                                />
                            )}
                        </Grid>
                        : null
                    }

                    {((this.state.data.type == "file&calendar" || this.state.data.type == "file")) ?
                        <Grid item mx={2}>
                            <MDButton color="warning" iconOnly onClick={() => this.props.openFileSystem()}>
                                <Icon>folder</Icon>
                            </MDButton>
                        </Grid>
                        : null
                    }


                    {(this.state.data.type == "file&calendar" || this.state.data.type == "calendar") ?
                        <Grid item xs={2}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"it"}>
                                <MobileDateTimePicker
                                    renderInput={(props) => (
                                        <MDButton variant={(this.state.data.date ? "gradient" : "outlined")} color={"info"} size="large" {...props} disabled={this.props.disabled}>
                                            {this.state.data.date ?
                                                dayjs(this.state.data.date).format("DD/MM/YYYY HH:mm")
                                                :
                                                <Icon>calendar_month</Icon>
                                            }
                                        </MDButton>
                                    )}
                                    label="Sopralluogo"
                                    onChange={(val) => this.saveData(val)}
                                    onAccept={(val) => this.saveData(val, true)}
                                    value={this.state.data.date}
                                    disablePast={true}
                                    disabled={this.props.disabled}
                                />
                            </LocalizationProvider>
                        </Grid>
                        : null
                    }

                    {(this.state.data.type == "boolean" || this.state.data.type == "file&calendar") ?
                        <Grid item mx={1}>
                            <Switch
                                checked={this.state.data.completed}
                                onChange={(val) => this.saveBool(val.target.checked)}
                                disabled={this.props.disabled}
                            />
                        </Grid>
                        : null
                    }
                    {!this.props.hideDocumentation ?
                        <Grid item mx={1}>
                            <MDTypography variant={"body2"}>Documentazione necessaria</MDTypography>
                            <Switch
                                checked={this.state.data.needed}
                                onChange={(val) => this.saveNeeded(val.target.checked)}
                                disabled={this.props.disabled}
                            />
                        </Grid>
                        : null
                    }

                </Grid>


            </MDBox>
        )

    }
}

export default CheckListCommessa;


CheckListCommessa.defaultProps = {

}
